<template>
  <div class="company-page t100-container">
    <div class="search-wrap">
      <a-input
        placeholder="請輸入設計公司名稱"
        class="search-input"
        v-model="keyword"
        @pressEnter="handleSearch"
      >
        <a-icon slot="prefix" type="search" @click="handleSearch" />
      </a-input>
    </div>

    <imgBorderContainer>
      <div class="company-list">
        <div class="tabs">
          <div class="tabs-header">
            <div
              class="tabs-item"
              v-for="item in tabs"
              :key="item.index"
              :class="{ active: item.index === currentIndex }"
              @click="currentIndex = item.index"
            >
              {{ item.name }}
            </div>
          </div>

          <div class="tabs-content">
            <list
              v-if="currentIndex === 0"
              :keyword="keyword"
              ref="list1"
            ></list>
          </div>
          <div class="tabs-content">
            <list :type="1" v-if="currentIndex === 1" :keyword="keyword"></list>
          </div>
          <div class="tabs-content">
            <list :type="2" v-if="currentIndex === 2" :keyword="keyword"></list>
          </div>
        </div>
      </div>
    </imgBorderContainer>
  </div>
</template>
<script>
import imgBorderContainer from "@/components/imgBorderContainer";
import imgBorderBtn from "@/components/imgBorderBtn";
import list from "./components/list";
export default {
  components: { imgBorderContainer, imgBorderBtn, list },
  data() {
    return {
      tabs: [
        { index: 0, name: "入圍公司" },
        { index: 1, name: "人氣獎入圍公司" },
        { index: 2, name: "新星獎入圍公司" },
      ],
      currentIndex: Number(this.$route.query.tab) || 0,
      keyword: "",
    };
  },
  mounted() {
    this.scrollToMain();
  },
  methods: {
    handleSearch() {
      this.currentIndex = 0;
      this.$refs.list1.getData();
    },
    scrollToMain() {
      setTimeout(() => {
        document.querySelector("#main").scrollIntoView({
          block: "start",
        });
      }, 300);
    },
  },
};
</script>
<style lang="less">
@import "~@/assets/styles/var.less";
.company-page {
  .search-wrap {
    text-align: right;
    @media (max-width: 768px) {
      padding-top: 10px;
    }
  }
  .search-input {
    width: 200px;
    .ant-input-prefix {
      color: @yellow;
      cursor: pointer;
    }
    font-size: 16px;
    input {
      background: transparent;
      border: 1px solid @yellow;
      border-radius: 20px;
      color: @yellow;
    }
  }
}
.company-list {
  color: #fff;
  position: relative;
  min-height: 300px;
  .tabs {
    position: relative;
    top: -8px;
    .tabs-header {
      white-space: nowrap;
      overflow: auto;
    }
    .tabs-item {
      cursor: pointer;
      display: inline-block;
      padding: 0 20px;
      font-size: 20px;
      color: @yellow;
      &.active {
        background-image: url("~@/assets/imgs/btn_border.png");
        background-size: 100% 100%;
        padding: 16px 80px 20px;
        font-size: 24px;
      }
    }
    .tabs-content {
      padding: 0 6px;
      margin-top: 16px;
    }
    @media (max-width: 768px) {
      .tabs-item {
        padding: 0 10px;
        font-size: 12px;
        &.active {
          padding: 8px 40px 10px;
          font-size: 14px;
        }
      }
    }
  }
  .company-card-col {
    margin-bottom: 20px;
  }
}
</style>